import { webToggles } from '@dustin-web/microsite-config'
import { WebTogglesWithOverrides } from '@dustin-web/microsite-config/src/web-toggles'
import React, { useCallback } from 'react'
import { useOptimizely } from './use-optimizely'

export const WebTogglesContext = React.createContext<WebTogglesWithOverrides>({
  ...webToggles,
  overrides: {},
})

export const useWebToggles = () => {
  const toggelitoToggles = React.useContext(WebTogglesContext)
  if (!toggelitoToggles) {
    throw new Error('useWebToggles must be used within a WebTogglesContext')
  }
  const { isToggleEnabled: isOptimizelyToggleEnabled } = useOptimizely()

  const isToggleEnabled = useCallback(
    (key: keyof WebTogglesWithOverrides): boolean => {
      if (key === 'overrides') {
        throw new Error('Cannot use `overrides` as a toggle key directly')
      }

      if (toggelitoToggles.overrides && toggelitoToggles.overrides[key]) {
        return toggelitoToggles.overrides[key]?.toLocaleLowerCase() === 'true' ? true : false
      }

      return !!(isOptimizelyToggleEnabled(key) ?? toggelitoToggles[key])
    },
    [toggelitoToggles, isOptimizelyToggleEnabled]
  )

  return {
    isToggleEnabled,
    toggles: {
      ...toggelitoToggles,
    },
  }
}
